import React, { lazy } from 'react';
import IconLaunch from '@/assets/images/menu/icon-launch.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const launchRoutes = (): IRouteConfig[] => [
  {
    path: '/launch',
    name: '启动',
    icon: <MenuIcon icon={IconLaunch} fontSize={16} />,
    sort: 92,
    authName: AuthNodes.Launch,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Flutter,
      CapitalPlatform.AppleTV,
    ],
    disabledByFree: true,
    routes: [
      {
        path: '/launch/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/launch/analytics')),
      },
      {
        path: '/launch/issues',
        name: '启动个例',
        component: lazy(() => import('@/presentation/pages/launch/issues')),
      },
    ],
  },
];

export default launchRoutes;
